/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiTransactionRelatedPersonCategory {
    CUSTOMER = 'CUSTOMER',
    COUNTERPARTY = 'COUNTERPARTY'
}


export function instanceOfInternalApiTransactionRelatedPersonCategory(value: any): boolean {
    for (const key in InternalApiTransactionRelatedPersonCategory) {
        if (Object.prototype.hasOwnProperty.call(InternalApiTransactionRelatedPersonCategory, key)) {
            if (InternalApiTransactionRelatedPersonCategory[key as keyof typeof InternalApiTransactionRelatedPersonCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiTransactionRelatedPersonCategoryFromJSON(json: any): InternalApiTransactionRelatedPersonCategory {
    return InternalApiTransactionRelatedPersonCategoryFromJSONTyped(json, false);
}

export function InternalApiTransactionRelatedPersonCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiTransactionRelatedPersonCategory {
    return json as InternalApiTransactionRelatedPersonCategory;
}

export function InternalApiTransactionRelatedPersonCategoryToJSON(value?: InternalApiTransactionRelatedPersonCategory | null): any {
    return value as any;
}

export function InternalApiTransactionRelatedPersonCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiTransactionRelatedPersonCategory {
    return value as InternalApiTransactionRelatedPersonCategory;
}

